import { newServer } from 'constants/constants';

export const API_ENDPOINTS = {
  getReportsPayment: `${newServer}reports/payment`,
  getReportsActivity: `${newServer}reports/activity`,
  saveReportsPayment: `${newServer}reports/payment`,
  saveReportsActivity: `${newServer}reports/activity`,
  getUsers: `${newServer}users/get-all`,
  createUser: `${newServer}users`,
  updateUser: `${newServer}users/update`,
  deleteUser: `${newServer}users/delete/`,
  archiveUser: `${newServer}users/archive/`,
  createdInvitation: `${newServer}users/invitation-user`,
  deleteInvitation: `${newServer}users/invitation-user/delete/`,
  getInfomationSubdomain: `${newServer}homepage/get-information-homepage-english?subdomain=`,
  getImageSubmerchant: `${newServer}aws/get-images?subdomain=`,
  getIdUser: `${newServer}users/get-id-user?id=`,
  updateInvitation: `${newServer}users/user-register`,
  getTokenUsed: `${newServer}users/get-used-token`,
  getInvitation: `${newServer}users/get-invitations`,
  updateInvitationUsed: `${newServer}users/update-code-invitation`,
  deleteInvitationGenerated: `${newServer}users/delete-invitation`,
};
